import axios from "./request"

export default {
  async get(query) {
    query.type = 6
    return (await axios.get('/extra-services', {
      params: query
    })).data[0]
  }
}
